import React from 'react';
import { Link } from 'react-router-dom';

function Solutions() {
  const solutions = [
    {
      id: 'practice-management',
      title: 'AI-Powered Practice Management',
      description: 'Transform your dental practice operations with our AI-driven comprehensive management solution.',
      features: [
        'AI Smart Scheduling',
        'Predictive Analytics',
        'Intelligent Patient Communication'
      ],
      image: '/assets/office1.png',
      benefits: [
        '40% reduction in administrative tasks',
        '95% scheduling accuracy',
        '24/7 automated support'
      ]
    },
    {
      id: 'patient-engagement',
      title: 'AI-Enhanced Patient Engagement',
      description: 'Build stronger relationships with patients through AI-powered communication and engagement tools.',
      features: [
        'Smart Automated Reminders',
        'AI-Powered Online Booking',
        'Intelligent Patient Portal'
      ],
      image: '/assets/dworkflow.png',
      benefits: [
        '85% patient satisfaction rate',
        '60% reduction in no-shows',
        'Real-time patient insights'
      ]
    },
    {
      id: 'clinical-tools',
      title: 'AI Clinical Tools',
      description: 'Advanced AI-powered clinical tools designed specifically for dental professionals.',
      features: [
        'AI Digital Charting',
        'Smart Treatment Planning',
        'AI Imaging Analysis'
      ],
      image: '/assets/3dmage.png',
      benefits: [
        '90% accuracy in treatment planning',
        '75% faster documentation',
        'Enhanced diagnostic capabilities'
      ]
    }
  ];

  return (
    <div className="pt-24">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-[#E5F0F3] to-white">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#1E2A4A] mb-6">
              AI Solutions for Modern Dental Practices
            </h1>
            <p className="text-xl text-gray-600">
              Discover how our AI-powered suite of solutions can transform your dental practice.
            </p>
          </div>
        </div>
      </div>

      {/* Solutions Grid */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution) => (
            <div key={solution.id} className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-shadow">
              <div className="relative">
                <img 
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-64 object-cover rounded-t-xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-t-xl" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1E2A4A] mb-3">
                  {solution.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {solution.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {solution.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-gray-600">
                      <svg className="w-5 h-5 text-orange-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link 
                  to={`/solutions/${solution.id}`}
                  className="inline-block w-full text-center bg-orange-500 text-white px-6 py-3 rounded-full font-medium hover:bg-orange-600 transition-colors"
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-[#1E2A4A] text-white">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">
              Ready to Transform Your Practice with AI?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join thousands of dental practices that have already modernized their operations with AI.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/schedule-demo"
                className="bg-orange-500 text-white px-8 py-3 rounded-full font-medium hover:bg-orange-600 transition-colors"
              >
                Schedule Demo
              </Link>
              <Link 
                to="/contact"
                className="bg-transparent text-white px-8 py-3 rounded-full font-medium border-2 border-white hover:bg-white/10 transition-colors"
              >
                Contact Sales
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Solutions; 